'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LORAX, OLAF } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import UIButton from 'UIComponents/button/UIButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import H5 from 'UIComponents/elements/headings/H5';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CommentModeCursorTooltip from './CommentModeCursorTooltip';
import OnboardingCloseAnchor from './OnboardingCloseAnchor';
const CommentModeIndicatorSharedStyle = css(["position:fixed;background-color:", ";overflow:hidden;z-index:", ";"], LORAX, URANUS_LAYER);
const TopIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__TopIndicator",
  componentId: "sc-1nf27pa-0"
})(["", " height:10px;width:100%;top:0;left:0;"], CommentModeIndicatorSharedStyle);
const BottomIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__BottomIndicator",
  componentId: "sc-1nf27pa-1"
})(["", " height:10px;width:100%;bottom:0;left:0;"], CommentModeIndicatorSharedStyle);
const LeftIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__LeftIndicator",
  componentId: "sc-1nf27pa-2"
})(["", " height:100%;width:10px;left:0;top:0;"], CommentModeIndicatorSharedStyle);
const RightIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__RightIndicator",
  componentId: "sc-1nf27pa-3"
})(["", " height:100%;width:10px;right:0;top:0;"], CommentModeIndicatorSharedStyle);
const ModeIndicator = styled(UIButton).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "CommentModeIndicator__ModeIndicator",
  componentId: "sc-1nf27pa-4"
})(["&&{", " right:0;top:0;border-bottom-left-radius:18px;}"], CommentModeIndicatorSharedStyle);
const ModeTitle = styled(H5).withConfig({
  displayName: "CommentModeIndicator__ModeTitle",
  componentId: "sc-1nf27pa-5"
})(["color:", ";margin:24px 60px 22px 30px;"], OLAF);

function CommentModeIndicator({
  onCancel
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TopIndicator, {}), /*#__PURE__*/_jsx(BottomIndicator, {}), /*#__PURE__*/_jsx(LeftIndicator, {}), /*#__PURE__*/_jsx(RightIndicator, {}), /*#__PURE__*/_jsxs(ModeIndicator, {
      onClick: onCancel,
      "data-test-id": "comment-mode-indicator",
      children: [/*#__PURE__*/_jsx(OnboardingCloseAnchor, {}), /*#__PURE__*/_jsx(ModeTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "collaborationSidebar.modals.commentMode.title"
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        className: "m-top-1 m-right-1",
        size: "medium"
      })]
    }), /*#__PURE__*/_jsx(CommentModeCursorTooltip, {})]
  });
}

CommentModeIndicator.propTypes = {
  onCancel: PropTypes.func.isRequired
};
export default CommentModeIndicator;